import { usePermissions } from "../../login/PermissionContext";

/**
 * Whether the calling user is the OT manager, i.e. holds `ot_admin` -- the
 * OT-manager function is a permission, not an actor (ADR-0007).
 *
 * Consumable orders, implant orders and OT orders are the OT manager's job:
 * the server refuses them to everyone else, so screens use this to disable
 * those controls rather than offer a click that can only fail. Same rule
 * OtShell applies to the Masters link.
 */
export function useIsOtManager() {
  const { permissions = [], userInfo } = usePermissions();
  const isSuperAdmin = userInfo?.role_permission?.[0]?.role === "super admin";
  return (
    isSuperAdmin ||
    permissions.some((p) => p.permission_name === "ot_admin" && p.is_accessible)
  );
}
